import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ServicioAesService } from './servicio-aes.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class ServicioAuthService {

  private AUTH_URL = '';
  private AUTHR_URL = '';

  constructor(private http: HttpClient, private aesEncrypt: ServicioAesService) { }

  public init() {
    this.AUTH_URL = environment.API_AUTHENTICATION;
    this.AUTHR_URL = environment.API_AUTH;
  }

  public isLogin(): boolean {
    const credential = localStorage.getItem('auth-report');
    if(credential) {
      const aesDecrypt = this.aesEncrypt.decrypt(credential);
      const token = aesDecrypt.split(' ')[1];
      return token ? true : false;
    }
    return false;
  }

  public login(token: string) {
    const tokenEncrypt = this.aesEncrypt.encrypt(token);
    localStorage.setItem('auth-report', tokenEncrypt);
  }

  public clearLogin() {
    localStorage.removeItem('auth-report');
  }

  public getValidateUsernameRequest(code: string, username: string) {
    this.init();
    const URL = `${this.AUTH_URL}/authorization/validate-username?code-parameter=${code}&username-parameter=${username}`;
    const HTTP_HEADER = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post(
      URL,
      { headers: HTTP_HEADER }
    );
  }

  public getValidatePasswordRequest(code: string, username: string, password: string) {
    password = password.replace('$', '%24');
    password = password.replace('#', '%23');
    password = password.replace('+', '%2B');
    this.init();
    const URL = `${this.AUTH_URL}/authorization/validate-password?code-parameter=${code}&username-parameter=${username}&pass-parameter=${password}`;
    const HTTP_HEADER = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post(
      URL,
      { headers: HTTP_HEADER }
    );
  }

  public getAuthRequest(code: string, username: string, password: string, idSede: number) {
    this.init();
    const URL = `${this.AUTHR_URL}/login?code=${code}&idSede=${idSede}`;
    const HTTP_HEADER = new HttpHeaders({ 'Content-Type' : 'application/json' });
    return this.http.post<HttpResponse<object>>(
      URL,
      {
        username,
        password
      },
      {
        headers: HTTP_HEADER,
        observe: 'response'
      }
    );
  }

  public getUsuarioToken() {
    const helper = new JwtHelperService();
    const credential = localStorage.getItem('auth-report');
    if(credential) {
      const aesDecrypt = this.aesEncrypt.decrypt(credential);
      const token = aesDecrypt.split(' ')[1];
      const decodeToken = helper.decodeToken(token);
      return decodeToken ? decodeToken.sub : '--';
    }
    return '';
  }

}

export interface UserLoginEntity {
  code: string;
  username: string;
  password: string;
  sedeId: number;
  url: string;
}
